(function () {
    'use strict';

    angular.module("imApp").factory("travExpTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getTravelExpenceType: function (parms) {
                return $ihttp.post({
                    method: 1271,
                    parameters: parms || {}
                });
            },
            listGlyphicons: function (parms) {
                return $ihttp.post({
                    method: 1270,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1272,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
